import React, { useState } from "react";
import styled from "styled-components";
import View from "common/View";
import { CONTEXT } from "common/chat/contexts/CONTEXT";
import {
  clearCustomContext,
  getCustomContext,
  setCustomContext,
} from "common/chat/contexts/customContext";

const Layout = styled.div`
  padding: 0 15px 15px;

  textarea {
    font-family: "GT-america-mono";
    font-size: 12px;
    line-height: 16px;
    width: 100%;
    height: 65vh;
    padding: 0.5em 0.75em;
    white-space: pre;
    resize: vertical;
    outline: none;
    background: var(--input-background-color, transparent);
    color: var(--Text-Primary);
    border: 1px solid var(--table-border-color, #ccc);
  }

  .actions {
    display: flex;
    gap: 10px;
    align-items: center;
    margin-top: 10px;
  }

  .status {
    margin-left: auto;
    font-size: 12px;
    color: var(--Text-Secondary, #888);
  }
`;

const ContextEditor = () => {
  const [text, setText] = useState(() => getCustomContext() ?? CONTEXT);
  const [isCustom, setIsCustom] = useState(() => getCustomContext() !== null);
  const [dirty, setDirty] = useState(false);

  const save = () => {
    setCustomContext(text);
    setIsCustom(true);
    setDirty(false);
  };

  const restore = () => {
    clearCustomContext();
    setText(CONTEXT);
    setIsCustom(false);
    setDirty(false);
  };

  const status = dirty
    ? "Unsaved changes"
    : isCustom
      ? "Using custom context (stored in this browser)"
      : "Using default context";

  return (
    <View title="AI Agent Context" refresh={null} bqnSelector={false}>
      <Layout>
        <textarea
          value={text}
          spellCheck={false}
          onChange={(event) => {
            setText(event.target.value);
            setDirty(true);
          }}
        />
        <div className="actions">
          <button
            type="button"
            className="btn btn-default waves-effect shadow-none"
            onClick={save}
            disabled={!dirty}
          >
            <i className="material-icons">save</i>
            <span>Save</span>
          </button>
          <button
            type="button"
            className="btn btn-default waves-effect shadow-none"
            onClick={restore}
            disabled={!isCustom && !dirty}
          >
            <i className="material-icons">restore</i>
            <span>Restore</span>
          </button>
          <span className="status">{status}</span>
        </div>
      </Layout>
    </View>
  );
};

export default ContextEditor;
